.button {
    background-color: var(--color-success);
    color: white;
    padding: 8px 16px;
    font-size: 1.5rem;
    border-radius: 8px;
    transition: background-color 0.4s ease;
}
.button:hover {
    background-color: var(--color-success-darker);
}
